const getUniquePresenceUpdates = (presenceUpdates) => {
  const uniquePresenceUpdates = {};

  presenceUpdates.forEach((presenceUpdate) => {
    uniquePresenceUpdates[presenceUpdate.childrenSelector] = presenceUpdate;
  });

  return Object.values(uniquePresenceUpdates);
};

export default getUniquePresenceUpdates;
